import http from '@/biz/http.mjs'
import {Confirm, useOpenModal} from '@/components/Modal'
import runAsync from '@/script/runAsync.mjs'
import commonApiArgs from './commonApiArgs.mjs'

export default ai => {
    const openModal = useOpenModal()

    return () => runAsync(
        async () => {
            try {
                const contents = [ai.getLastMessage().content]

                return await http.post(
                    '/ai/parse',
                    {...commonApiArgs(ai), contents}
                )
            }
            catch (err) {
                if (/^012100(19|20)$/.test(err.code)) {
                    const isConfirmed = await openModal(
                        <Confirm okText="智能修复">
                            {err.message}
                        </Confirm>
                    )

                    if (isConfirmed) {
                        ai.addMessage({
                            content: '输出的表格缺少===TABLE_START===和===TABLE_END===标签',
                            files: [],
                            role: 'user',
                        })

                        ai.run()
                    }
                }
                else {
                    throw err
                }
            }
        },

        {action: '生成文件'}
    )
}
